import React from 'react';
import TuvCertificateMessage from '@core/components/tuvcertificatemessage/TuvCertificateMessage';

import TuvImage from 'assets/images/pages/plans/certificates.png';

import classes from './CertifiedTrust.module.scss';


const certificateBullets = [
    'Complete individual courses to earn course certificates,',
    'Finish a structured career path to receive a career-path certificate demonstrating broader knowledge across a specific professional area.'
];

const CertifiedTrust = () => {
    return (
        <div className={classes['certificate-wrapper']}>
            <div className='container'>
                <div className={`row align-items-center ${classes['certificate']}`}>
                    <div className='col-lg-7 col-12'>
                        <h3>Build Skills. Complete Courses &amp; Career Paths. Earn Certificates.</h3>
                        <p>
                            All Pharmuni courses and career paths are developed under the ISO 9001 certification of Quality Management System of Zamann Pharma Support GmbH.
                        </p>
                        <ul className={classes['bullets']}>
                            {certificateBullets.map((bullet) =>
                                <li key={bullet}>{bullet}</li>
                            )}
                        </ul>
                    </div>
                    <div className='col-lg-5 col-12'>
                        <div className={classes['image-wrapper']}>
                            <img src={TuvImage.src} alt='Pharmuni course and career path certificates issued under a TÜV SÜD-certified ISO 9001 quality management system' />
                        </div>
                        <TuvCertificateMessage />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CertifiedTrust;
